import { GridSortModel } from '@mui/x-data-grid';
import { GridFilterModel } from '@mui/x-data-grid-pro';

import usePaginatedQuery from 'src/hooks/usePaginatedQuery';
import { PaginationMetadata, UsePaginatedQueryConfig } from 'src/hooks/usePaginatedQuery/type';

export interface UseTableResult<T = unknown> {
    rows: T[];
    loading: boolean;
    error: unknown;
    pagination: PaginationMetadata;
    fetchMore: (options: { page: number; pageSize?: number }) => Promise<unknown>;
    updateSorting: (sortModel: GridSortModel) => void;
    updateFilters: (filters: GridFilterModel) => void;
    sortState: GridSortModel;
    filterState?: GridFilterModel;
    networkStatus: number;
    reset: () => void;
}

function useTable<T = unknown>(config: UsePaginatedQueryConfig): UseTableResult<T> {
    const {
        data,
        loading,
        error,
        paginationMetadata,
        fetchMore,
        updateSorting,
        updateFilters,
        currentSorting,
        filterState,
        networkStatus,
        reset,
    } = usePaginatedQuery<T>(config);

    return {
        rows: data,
        loading,
        error,
        pagination: paginationMetadata,
        fetchMore,
        updateSorting,
        updateFilters,
        sortState: currentSorting,
        filterState,
        networkStatus,
        reset,
    };
}

export default useTable;
